import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getEventDetails(token) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getEventDetails.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          // ✅ FIX: Parse diretto senza unescapeString
          // Utils.unescapeString() rimuove i backslash VALIDI da \" causando JSON invalido
          // JSON.parse() gestisce correttamente le sequenze di escape come \"
          const resp = JSON.parse(body.toString());
          resolve(resp);
        } catch (error) {
          console.error("[getEventDetails] ERRORE nel parsing JSON:", error);
          console.error("[getEventDetails] Response raw:", body.toString());
          reject(error);
        }
      });
      res.on("error", function(error) {
        console.error(error);
      });
    });

    var postData = qs.stringify({
      token: token,
    });

    req.write(postData);

    req.end();
  });
}
